if (!customElements.get('tanoti-style-card')) {
  customElements.define('tanoti-style-card', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-print]');
        if (!swatch || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        this.querySelectorAll('[data-product-link]').forEach(link => { link.href = swatch.href; });
        const image = this.querySelector('.tanoti-style-card__image img');
        if (image && swatch.dataset.image) {
          image.removeAttribute('srcset');
          image.src = swatch.dataset.image;
          image.alt = swatch.dataset.alt;
          this.querySelector('collection-image-carousel')?.reset(swatch.dataset.image);
        }
        this.querySelector('[data-style-price]').replaceChildren(swatch.querySelector('template').content.cloneNode(true));
        this.querySelector('[data-print-name]').textContent = swatch.dataset.print;
        this.querySelectorAll('[data-print]').forEach(link => link.removeAttribute('aria-current'));
        swatch.setAttribute('aria-current', 'true');
      });
    }
  });
}

if (!customElements.get('tanoti-size-guide')) {
  customElements.define('tanoti-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const tables = [...this.querySelectorAll('table')];
      const sourceUnit = this.dataset.sourceUnit;
      // Convert only known numeric measurement cells, never sizes or arbitrary page text.
      const values = [];
      const unitLabels = [];
      tables.forEach(table => {
        const rows = [...table.rows];
        const header = rows.find(row => /chest|bust|waist|hip|length|shoulder|sleeve/i.test(row.textContent));
        if (!header) return;
        const measurementColumns = [...header.cells].map(cell => /chest|bust|waist|hip|length|shoulder|sleeve/i.test(cell.textContent));
        [...header.cells].forEach(cell => {
          if (/\b(inches|inch|cm)\b/i.test(cell.textContent)) unitLabels.push({cell, original: cell.textContent});
        });
        rows.slice(rows.indexOf(header) + 1).forEach(row => {
          [...row.cells].forEach((cell, index) => {
            const raw = cell.textContent.trim();
            if (!measurementColumns[index]) {
              if (/^XXL$/i.test(raw)) cell.textContent = '2XL';
              return;
            }
            if (/^\d+(\.\d+)?$/.test(raw)) values.push({cell, value: Number(raw), original: raw});
          });
        });
      });
      const controls = this.querySelector('[data-unit-controls]');
      if (!values.length || !['in', 'cm'].includes(sourceUnit)) return;
      controls.hidden = false;
      const convert = (unit) => {
        controls.dataset.activeUnit = unit;
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.querySelector('.tanoti-size-guide__table').animate([{opacity: .35, transform: 'translateY(4px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 240, easing: 'ease-out'});
        }
        values.forEach(({cell, value, original}) => {
          cell.textContent = unit === sourceUnit ? original : String(Math.round((sourceUnit === 'in' ? value * 2.54 : value / 2.54) * 10) / 10);
        });
        unitLabels.forEach(({cell, original}) => { cell.textContent = original.replace(/\b(inches|inch|cm)\b/gi, unit === 'in' ? 'inches' : 'cm'); });
        controls.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.unit === unit)));
        this.querySelector('[data-unit-status]').textContent = `Measurements in ${unit === 'in' ? 'inches' : 'centimetres'}.`;
      };
      controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-unit]');
        if (button) convert(button.dataset.unit);
      });
      convert(sourceUnit);
    }
  });
}
